module.exports = __webpack_public_path__ + "shanz/static/media/Toys.ba1e2ec4.png";